import React from 'react';
import {Link, useParams} from 'react-router-dom';

import clsx from 'clsx';
import {ACCOUNT_TABS} from 'src/constants';

import {Group} from '@pb/kit-component-group';


import {
    userCountItemDisabled,
    userCountItemValue,
} from './user-count-item.module.styl';

type Props = {
    value: number,
};

export const VirtualUsersCountItem: React.FC<Props> = ({value}) => {
    const {accountId} = useParams<{accountId?: string, userSearchStateCriteria?: string}>();

    const classes = clsx([!value && userCountItemDisabled]);

    return (
        <Group gap="l" className={classes} alignItems="center">
            <strong style={{width: 150}}>Conference Users</strong>
            <span className={userCountItemValue}>
                {value ? (
                    <Link to={`/profile/account/${accountId}/${ACCOUNT_TABS.USERS.name}/virtual`}>
                        <strong>{value}</strong>
                    </Link>
                ) : '--'}
            </span>
        </Group>
    );
};
